<template>
  <v-row no-gutters>
    <v-spacer></v-spacer>
    <v-col cols="4" class="text-right">
      <v-btn
      depressed
        v-if="needsCancelButton"
        :loading="isLoading"
        :disabled="isLoading"
        @click="ignore()"
      >
        {{ ignoreButtonName }}
      </v-btn>
      <v-btn
      depressed
        color="success"
        :loading="isLoading"
        class="ml-4"
        :disabled="isLoading"
        @click="approve()"
      >
        {{ successButtonName }}
      </v-btn>
    </v-col>
  </v-row>
</template>
  
  <script>
export default {
  props: [
    "needsCancelButton",
    "ignoreButtonName",
    "successButtonName",
    "validation",
  ],
  data() {
    return {
      isLoading: false,
    };
  },
  methods: {
    ignore() {
      this.isLoading = true;
      setTimeout(() => {
        this.$emit("deleteOutArray", this.validation.Id);
        this.isLoading = false;
      }, 1000);
    },
    approve() {
      this.isLoading = true;

      setTimeout(() => {
        this.$emit("deleteOutArray", this.validation.Id);
        this.isLoading = false;
      }, 1000);
    },
  },
};
</script>
  
  <style>
</style>